<li data-id="{{id}}" class="arround__item">
    <div class="arround-info">
        <span class="arround-name">{{name}}</span>
        <span class="arround-price">{{price}} <span class="arround-currency">uah</span></span>
    </div>
    <img src="{{image}}" alt="{{name}}" class="arround-img">
</li>